package com.willandsons.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.willandsons.HeadlineTextStyle
import com.willandsons.components.layouts.PageLayoutData
import kotlinx.browser.window
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span

@InitRoute
fun initDeleteAccountPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Delete Account"))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun DeleteAccountPage() {
    val ctx = rememberPageContext()
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        val host = window.location.hostname
        val apps = mapOf(
            "lovenearby" to "LoveNearby"
        )
        var selectedApp: String? by remember { mutableStateOf(null) }
        LaunchedEffect(host) {
            val parts = host.split(".")
            val subdomain = if (parts.size > 2) parts[0] else null

            val validSubdomains = apps.keys

            when (subdomain) {
                null -> {
                    ctx.router.tryRoutingTo("/404")
                }

                in validSubdomains -> {
                    selectedApp = subdomain
                }

                else -> {
                    ctx.router.tryRoutingTo("/404")
                }
            }
        }
        if (selectedApp != null) {
            Column {
                Div(
                    Modifier
                        .fontSize(3.cssRem)
                        .fontWeight(400)
                        .margin(bottom = 2.5.cssRem)
                        .lineHeight(1.2)
                        .textAlign(TextAlign.Center).toAttrs()
                ) {
                    SpanText("Delete Account for ${apps[selectedApp]}")
                }
                Span {
                    SpanText("To delete your ${apps[selectedApp]} account, please send an email to ")
                    Link("mailto:delete-account@${selectedApp}.willandsons.com", "delete-account@${selectedApp}.willandsons.com")
                    SpanText(" from the email address associated with your account. We will process your request as soon as possible.")
                }
            }
        } else {
            SpanText("Loading...", HeadlineTextStyle.toModifier())
        }
    }
}
